import PropTypes from 'prop-types';
import clsx from 'clsx';
import MLink from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import DirectionsIcon from '@material-ui/icons/Directions';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import WeekendIcon from '@material-ui/icons/Weekend';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import InlineMarkdown from '../inline-markdown';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(0, 0, 2, 0)
  },
  name: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  nameHidden: {
    marginLeft: theme.spacing(0.5),
    fontStyle: 'italic',
  },
  mainIcon: {
    marginRight: theme.spacing(0.5),
  },
  meta: {
    marginLeft: theme.spacing(3.5),
  },
  details: {
    fontStyle: 'italic',
  },
  mapLink: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
  },
  mapIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
  loop: {
    display: 'flex',
    alignItems: 'center',
  },
  loopIcon: {
    marginRight: theme.spacing(0.5),
  },
}));

const EventLocation = ({ event, type, className, ...rest }) => {
  const classes = useStyles();

  const {
    [`${type}Location`]: name,
    [`${type}LocationAddress`]: address,
    [`${type}LocationDetails`]: details,
    loop,
    eventType,
    permissions,
  } = event;

  // don't return null if not approved and type is start so we can say location hidden
  if (!name && !address && (permissions.approved || type !== 'start')) {
    return null;
  }

  const mapQuery = address || name;
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQuery)}`;

  return (
    <div className={clsx(classes.wrapper, className)} {...rest}>
      <div className={classes.name}>
        {type === 'end'
          ? <WeekendIcon className={classes.mainIcon} />
          : <LocationOnIcon className={classes.mainIcon}/>}
        {eventType === 'RIDE' && (type === 'start' ? 'Start: ' : 'End: ')}
        {permissions.approved ? name : <span className={classes.nameHidden}>Location hidden</span>}
      </div>
      {permissions.approved && (
        <div className={classes.meta}>
          {address && <div className={classes.address}>{address}</div>}
          {details && (
            <div className={classes.details}>
              <InlineMarkdown>{details}</InlineMarkdown>
            </div>
          )}
          {type === 'start' && loop && (
            <div className={classes.loop}>
              <AllInclusiveIcon fontSize="small" className={classes.loopIcon} />
              Ride is a Loop
            </div>
          )}
          <MLink href={mapUrl} className={classes.mapLink}>
            <DirectionsIcon className={classes.mapIcon} />
            Open Map
          </MLink>
        </div>
      )}
    </div>
  );
};

EventLocation.propTypes = {
  event: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default EventLocation;
